type SectionTitleProps = {
  kicker: string;
  title: string;
  desc?: string;
  action?: { label: string; href: string };
  tone?: 'default' | 'inverse';
};

export default function SectionTitle({ kicker, title, desc, action, tone = 'default' }: SectionTitleProps) {
  const isInverse = tone === 'inverse';
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-6 md:mb-8">
      <div className="max-w-2xl">
        <div className={`flex items-center gap-2 mb-2 ${isInverse ? 'text-accent-300' : 'text-primary-600'}`}>
          <span className={`h-3 w-1 rounded-full ${isInverse ? 'bg-accent-400' : 'bg-primary-500'}`} />
          <span className="font-label text-xs tracking-[0.28em] uppercase">{kicker}</span>
        </div>
        <h2 className={`font-heading font-bold text-2xl md:text-[32px] leading-snug ${isInverse ? 'text-background-50' : 'text-foreground-950'}`}>
          {title}
        </h2>
        {desc ? (
          <p className={`mt-2 text-sm leading-relaxed ${isInverse ? 'text-background-100/75' : 'text-foreground-600'}`}>{desc}</p>
        ) : null}
      </div>
      {action ? (
        <a
          href={action.href}
          className={`group inline-flex items-center gap-2 text-sm whitespace-nowrap cursor-pointer ${
            isInverse ? 'text-background-50 hover:text-accent-300' : 'text-foreground-700 hover:text-primary-600'
          }`}
        >
          {action.label}
          <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
        </a>
      ) : null}
    </div>
  );
}